import Modal from "common/Modal";
import { ModalHeader, Separator } from "common/Modal/styled";
import React from "react";
import styled from "styled-components";

import metamask from "assets/metamask.png";
import trustWallet from "assets/trustWallet.png";
import { useDispatch } from "react-redux";
import { walletActions } from "stores/reducers/wallet";
import { connectByEthereumProvider } from "services/wallet";

export interface IConnectWalletModal {
  isOpen: boolean;
  setOpen: Function;
  handleSelectWallet: Function;
}

interface IOption {
  id: number;
  connectMethod: ConnectWalletMethod;
  label: string;
  img: any;
}

const ConnectWalletModal = ({
  isOpen,
  setOpen,
  handleSelectWallet,
}: IConnectWalletModal) => {
  const dispatch = useDispatch();

  const connectWallet = async (method: ConnectWalletMethod) => {
    if (method === "METAMASK" || "TRUST_WALLET") {
      const data = await connectByEthereumProvider(method, dispatch);
      dispatch(walletActions.connectWalletSuccess(data));
    } 

    /* if(method === "WALLET_CONNECT"){
      const data = await connectByWalletConnect(dispatch);
      dispatch(walletActions.connectWalletSuccess(data));
    } */
  };

  const options: IOption[] = [
    {
      id: 0,
      connectMethod: "METAMASK",
      label: "Metamask",
      img: metamask,
    },
    {
      id: 1,
      connectMethod: "TRUST_WALLET",
      label: "TrustWallet",
      img: trustWallet,
    },
    /* {
      id: 2,
      connectMethod: "WALLET_CONNECT",
      label: "WalletConnect - To be dev",
      img: walletConnect,
    }, */
  ];
  return (
    <>
      <Modal isOpen={isOpen} setOpen={setOpen}>
        <Wrapper>
          <ModalHeader>Connect Wallet</ModalHeader>

          <Separator />

          <WalletMenu>
            {options.map((opt, idx) => {
              return (
                <WalletOption
                  key={opt.id || idx}
                  onClick={() => connectWallet(opt.connectMethod)}
                >
                  <div>{opt.label}</div>
                  <img src={opt.img} alt={opt.connectMethod} />
                </WalletOption>
              );
            })}
          </WalletMenu>
        </Wrapper>
      </Modal>
    </>
  );
};

export default ConnectWalletModal;

const Wrapper = styled.div`
  color: ${(p) => p.theme.textSecondary};
  width: 300px;
  height: 100%;
`;

const WalletMenu = styled.ul``;

const WalletOption = styled.li`
  list-style-type: none;
  background: ${(p) => p.theme.secondary};
  color: ${(p) => p.theme.primary};
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  transition: 0.275s;
  font-weight: 500;

  &:hover {
    background-color: ${(p) => p.theme.backgroundPrimaryHover};
    font-size: 1.1rem;
    font-weight: 600;
  }
`;
